import React from "react";
import "./square.css";

export default function Square( { square } )
{
  return (
    <div className={ `square ${ square.state ? "sorted" : "" }` }>
      <div className="char">{ square.char }</div>
      <div>{ square.id }</div>
      { square.orden !== null && (
        <div className="orden">#{ square.orden }</div>
      ) }
    </div>
  );
} 